import * as ambassadorWixMediaSiteMediaV1Folder from './media-site-media-v1-folder-folders.http.js';
import * as ambassadorWixMediaSiteMediaV1FolderTypes from './media-site-media-v1-folder-folders.types.js';
import * as ambassadorWixMediaSiteMediaV1FolderUniversalTypes from './media-site-media-v1-folder-folders.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createFolder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.CreateFolderRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.CreateFolderRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.CreateFolderResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.CreateFolderResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.createFolder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/folders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getFolder(): __PublicMethodMetaInfo<
  'GET',
  { folderId: string },
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.GetFolderRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.GetFolderRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.GetFolderResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.GetFolderResponse
> {
  const payload = { folderId: ':folderId' } as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.getFolder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/folders/{folderId}',
    pathParams: { folderId: 'folderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listFolders(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.ListFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.ListFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.ListFoldersResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.ListFoldersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.listFolders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/folders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchFolders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.SearchFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.SearchFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.SearchFoldersResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.SearchFoldersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.searchFolders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/folders/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateFolder(): __PublicMethodMetaInfo<
  'PATCH',
  { folderId: string },
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.UpdateFolderRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.UpdateFolderRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.UpdateFolderResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.UpdateFolderResponse
> {
  const payload = { folder: { id: ':folderId' } } as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.updateFolder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/folders/{folder.id}',
    pathParams: { folderId: 'folderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateFolderDownloadUrl(): __PublicMethodMetaInfo<
  'POST',
  { folderId: string },
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.GenerateFolderDownloadUrlRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.GenerateFolderDownloadUrlRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.GenerateFolderDownloadUrlResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.GenerateFolderDownloadUrlResponse
> {
  const payload = { folderId: ':folderId' } as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.generateFolderDownloadUrl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/folders/{folderId}/generate-download-url',
    pathParams: { folderId: 'folderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteFolders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.BulkDeleteFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.BulkDeleteFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.BulkDeleteFoldersResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.BulkDeleteFoldersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.bulkDeleteFolders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/folders/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkRestoreFoldersFromTrashBin(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.BulkRestoreFoldersFromTrashBinRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.BulkRestoreFoldersFromTrashBinRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.BulkRestoreFoldersFromTrashBinResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.BulkRestoreFoldersFromTrashBinResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.bulkRestoreFoldersFromTrashBin(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/trash-bin/folders/restore',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDeletedFolders(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.ListDeletedFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.ListDeletedFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.ListDeletedFoldersResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.ListDeletedFoldersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.listDeletedFolders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/trash-bin/folders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryFolders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.QueryFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderTypes.QueryFoldersRequest,
  ambassadorWixMediaSiteMediaV1FolderUniversalTypes.QueryFoldersResponse,
  ambassadorWixMediaSiteMediaV1FolderTypes.QueryFoldersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaSiteMediaV1Folder.queryFolders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/folders/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Folder as FolderOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  CreateFolderRequest as CreateFolderRequestOriginal,
  CreateFolderResponse as CreateFolderResponseOriginal,
  GetFolderRequest as GetFolderRequestOriginal,
  GetFolderResponse as GetFolderResponseOriginal,
  ListFoldersRequest as ListFoldersRequestOriginal,
  CommonSorting as CommonSortingOriginal,
  CommonSortOrder as CommonSortOrderOriginal,
  CommonSortOrderWithLiterals as CommonSortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  CursorPaging as CursorPagingOriginal,
  ListFoldersResponse as ListFoldersResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  SearchFoldersRequest as SearchFoldersRequestOriginal,
  RootFolder as RootFolderOriginal,
  RootFolderWithLiterals as RootFolderWithLiteralsOriginal,
  SearchFoldersResponse as SearchFoldersResponseOriginal,
  UpdateFolderRequest as UpdateFolderRequestOriginal,
  UpdateFolderResponse as UpdateFolderResponseOriginal,
  UnsupportedRequestValueError as UnsupportedRequestValueErrorOriginal,
  GenerateFolderDownloadUrlRequest as GenerateFolderDownloadUrlRequestOriginal,
  GenerateFolderDownloadUrlResponse as GenerateFolderDownloadUrlResponseOriginal,
  BulkDeleteFoldersRequest as BulkDeleteFoldersRequestOriginal,
  BulkDeleteFoldersResponse as BulkDeleteFoldersResponseOriginal,
  BulkRestoreFoldersFromTrashBinRequest as BulkRestoreFoldersFromTrashBinRequestOriginal,
  BulkRestoreFoldersFromTrashBinResponse as BulkRestoreFoldersFromTrashBinResponseOriginal,
  ListDeletedFoldersRequest as ListDeletedFoldersRequestOriginal,
  ListDeletedFoldersResponse as ListDeletedFoldersResponseOriginal,
  QueryFoldersRequest as QueryFoldersRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryFoldersResponse as QueryFoldersResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateFolderValidationErrors as UpdateFolderValidationErrorsOriginal,
} from './media-site-media-v1-folder-folders.types.js';
